// 公共工具初始化

// 原生对象拓展，兼容低版本浏览器语法
import './prototype_expand'
// 跳转
import './jump'
// 工具类
import './tool'
// jquery
import './deferred'
// 企业用户配置数据统一入口
import ZConfig from './ZConfig'
// 数据请求封装
import { getHttpService } from './http'
// 时间处理工具
// import Moment from 'moment'

import Map from './map/map'


// 不同环境中加载不同的资源
function loadEnvJS(callback) {
  if ($jump.env.dd) { // 钉钉环境初始化
    $tool.loadScript('https://g.alicdn.com/dingding/dingtalk-jsapi/3.0.47/dingtalk.open.js', function (rs) {
      if (rs && window.dd) {
        // window.dd.biz.navigation.setTitle({
        //   title: $ZConfig.getVal('NAME')
        // })
        window.dd.ready(callback)
        window.dd.error(function (err) {
          alert('dd error: ' + JSON.stringify(err))
        })
      } else {
        alert('网络异常，请退出重试[001]')
      }
    });
  } else if ($jump.env.feishu) { // 飞书应用中
    $tool.loadScript('https://lf1-cdn-tos.bytegoofy.com/goofy/ee/lark/h5jssdk/lark/js_sdk/h5-js-sdk-1.5.12.js', function (rs) {
      if (window.h5sdk) { // 飞书jsbug，须在index.html加载js
        window.h5sdk.ready(callback)
      } else {
        alert('网络异常，请退出重试[003]')
      }
    });
  } else {
    callback()
  }
}
// 适配是否已登录的授权, 
export default async function (withAuth = true ) {
  if (!withAuth) {
    await ZConfig.init(withAuth)
  } else {    
    // window._ = _
    // Moment.locale('zh-cn')
    // window.moment = Moment
    await ZConfig.init()
    getHttpService()

    await new Promise(resolve => {
      loadEnvJS(resolve)
    })

    //公共组件图标
    let wxmj = $tool.loadScript('//at.alicdn.com/t/font_1267007_sm35l0xo8f.js', null, 'wxm-font-js')
    let wxmc = $tool.loadCSS('//at.alicdn.com/t/font_1267007_sm35l0xo8f.css', 'wxm-font-css')
    wxmj && wxmj.remove()
    wxmc && wxmc.remove()

    // 挂载全局定位
    // $tool.map = new Map()
    $tool.webMap = new Map()
  }
}

